import { DownloadItem } from '@/types';

export const priceListDownloads: DownloadItem[] = [
  {
    id: 'product',
    name: 'headers.productPriceList',
    type: 'excel',
  },
  {
    id: 'print',
    name: 'headers.completePrintingPriceList',
    type: 'excel',
  },
];
